export enum AccountIdentifier {
    FACEBOOK = 'facebook',
    GOOGLE = 'google',
}
